import { css } from 'linaria';

export const goToCartButtonClass = css`
  padding: var(--space-150) var(--space-300);

  @media (--only-mobile) {
    padding: var(--space-100) var(--space-150);
  }
`;
